global.dataLayer = global.dataLayer || []
export type GtagEvent = {
  event?: string
  eventData?: string
  eventLabel?: string
}

/**
 * Track an event
 * Supply a callback, that gets triggered after the event is tracked
 */
export function trackEvent({ event, eventData, eventLabel }: GtagEvent) {
  if (typeof window === 'undefined') return
  const eventName = event ? `${window.site_section || 'pensam'}-${event}` : ''
  const gtmEvent = {
    event: eventName,
    'event-data': eventData || '',
    'event-label': eventLabel || '',
  }

  if (global.dataLayer && gtmEvent.event) {
    global.dataLayer.push(gtmEvent)
  } //
  // if (
  //   process.env.NODE_ENV === 'development' &&
  //   global.dataLayer &&
  //   gtmEvent.event
  // ) {
  //   console.log('dataLayer', global.dataLayer)
  // }
}
